import { reactive } from 'vue'
import PublicPageResp from '@/interface/api/PublicPageResp'
import router from '@/router';
import urls from "@/URLs";

class RouteState {

    //.tsではうまく型定義できない。この辺がクラスベースVueの限界っぽいな。。
    public rootInstance = null as any;

    //Projectページに、Projectオブジェクトを渡して遷移する。
    //詳細を取得済みの状態で、移動先のページで再度取得するのはちょっともったいないため（気にしすぎ？）
    //vue-routerのpropsの制限により、深さ2以上のプロパティを持つObjectを渡すと、以降のプロパティが文字列化されてしまうのを回避する
    //（恐らくvue-router自体、URLのQueryStringしか頭にないためこの挙動となっている）
    private publicPage:PublicPageResp|null = null;

    //APIにひとつ前のページに戻る機能があるので、ブラウザバックで動作させるか判定する
    private isComeFromSameDomain = false;

    public goToPublicPage(publicPage:PublicPageResp){
        this.publicPage = publicPage;
        this.isComeFromSameDomain = true;
        router.push(urls.getPublicPageURL(publicPage));
    }

    public recievePublicPageFromPreviousPage(){
        const ret = this.publicPage
        this.publicPage = null
        return ret;
    }

    public goBackUI(){
        if(this.isComeFromSameDomain){
            window.history.back();
        }else{
            router.push("/");
        }
    }
}

//複数のvueで変数の値を共有したいので、事前にnewしてreactive化したものを渡す。
export default reactive(new RouteState);
